import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { createReportIssue } from "../../../components/Header/Data3";
import { toast } from "react-toastify";

const ReportUser = ({ isOpen, closeModal }) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [otherReason, setOtherReason] = useState("");
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const handleReasonChange = (event) => {
    console.log(event.target.value, "selectedReason");
    setSelectedReason(event.target.value);
    if (event.target.value === "4" || event.target.value === "3") {
      console.log("Resetting other reason");
      setOtherReason("");
    }
  };

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };

  const vendorReasons = [
    { value: 1, label: "Customer is no longer within the market" },
    { value: 2, label: "Unresponsive for 3+ days" },
    { value: 3, label: "Cancel the offer " },
    { value: 4, label: "Other" },
  ];
  const customerReasons = [
    {
      value: 11,
      label: "Vendor is spamming",
      type: "customer",
    },
    {
      value: 12,
      label: "Vendor is harassing",
      type: "customer",
    },
    {
      value: 13,
      label: "Other",
      type: "customer",
    },
  ];
  const reasons =
    selectedConvo.createdBy === user.UserID ? vendorReasons : customerReasons;

  const handleReport = async () => {
    if (!selectedReason) {
      toast.error("Please select a reason");
      return;
    }
    let formData = {
      messageId: selectedConvo?.Id,
      Reason: selectedReason,
      Comment: otherReason,
      createdBy: user?.UserID,
      reportedEntity:
        selectedConvo?.createdBy === user?.UserID
          ? selectedConvo?.customerId
          : selectedConvo?.createdBy,
    };

    if (selectedReason === "Other") {
      formData.otherReason = otherReason;
    }
    await createReportIssue(formData);
    setOtherReason("");
    setSelectedReason(null);
    closeModal();
  };
  return (
    <Modal isOpen={isOpen} toggle={closeModal}>
      <ModalHeader toggle={closeModal} className="bg-primary text-white">
        <h5 className="modal-title">
          Report{" "}
          {selectedConvo.createdBy !== user.UserID
            ? selectedConvo?.senderName
            : selectedConvo?.customerName}
        </h5>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-md-12">
            <h6>Reason for reporting:</h6>
            {reasons.map((reason) => (
              <div key={reason.value} className="form-check">
                <Input
                  type="radio"
                  name="reason"
                  value={reason.label}
                  id={`reason-${reason.label}`}
                  checked={selectedReason === reason.label}
                  onChange={handleReasonChange}
                  className="form-check-input"
                />
                <Label
                  htmlFor={`reason-${reason.label}`}
                  className="form-check-label"
                >
                  {reason.label}
                </Label>
                {reasons.length - 1 ===
                  reasons.findIndex((r) => r.label === reason.label) &&
                  selectedReason === reason.label && (
                    <Input
                      type="textarea"
                      value={otherReason}
                      onChange={handleOtherReasonChange}
                      placeholder="Please specify the reason"
                      className="form-control mt-2"
                    />
                  )}
              </div>
            ))}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleReport}>
          Submit
        </Button>
        <Button color="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReportUser;
